import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import ServicesContext from "./contexts/servicesContext";
import DictionaryService from "./services/dictionaryService";
import EnrolleeService from "./services/enrolleeService";
import AuthService from "./services/authService";
import AdmissionInfoService from "./services/admissionInfoService";
import FileUploadService from "./services/fileUploadService";
import PersonalPageService from "./services/personalPageService";
import EducationInfoService from "./services/educationInfoService";
import DocumentPageService from "./services/documentPageService";
import PersonalSettingsService from "./services/profileSettingsService";
import SecretaryService from "./services/secretaryService";
import CreateUsersService from "./services/createUsersService";
import DormAccomodation from "./services/dormAccomodationService";
import StudentAffairsService from "./services/studentAffairsService";
import CenterKatoService from "./services/centerKatoService";
import AetService from "./services/aetService";
import EpvoService from "./services/epvoService";
import IdCardService from "./services/idCardService";
import { AlertProvider } from "./contexts/AlertProvider";
import AchievementInfoService from "./services/achievementInfoService";
import ContractService from "./services/contractService";
import DormContractService from "./services/dormContractService";

const services = {
  auth: new AuthService(),
  dictionary: new DictionaryService(),
  enrollee: new EnrolleeService(),
  admissionInfo: new AdmissionInfoService(),
  educationInfo: new EducationInfoService(),
  personalPage: new PersonalPageService(),
  fileUpload: new FileUploadService(),
  documentPage: new DocumentPageService(),
  personalSettingsService: new PersonalSettingsService(),
  secretary: new SecretaryService(),
  createUsers: new CreateUsersService(),
  dormAccomodation: new DormAccomodation(),
  studentAffairs: new StudentAffairsService(),
  centerKato: new CenterKatoService(),
  aet: new AetService(),
  epvo: new EpvoService(),
  idCard: new IdCardService(),
  achievementInfo: new AchievementInfoService(),
  contract: new ContractService(),
  dormContract: new DormContractService(),
};

ReactDOM.render(
  <Router>
    <ServicesContext.Provider value={services}>
      <AlertProvider>
        <App />
      </AlertProvider>
    </ServicesContext.Provider>
  </Router>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
